
import {
  defineComponent, reactive,
  watch,
} from 'vue';
import { IColumn } from '@/core/models/AntDesign/IColumn';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import UtilitarioData from '@/core/utilitarios/UtilitarioData';
import { EFiltroPeriodoMovimentoComercial } from '@/models/Enumeradores/Compartilhados/EFiltroPeriodoMovimentoComercial';
import Card from '@/core/components/Tela/Card.vue';
import Icone from '@/core/components/Icone.vue';
import { EStatusPedidoCompra } from '@/models/Enumeradores/Compras/EStatusPedidoCompra';
import { IDTOPedidoCompra } from '@/models/DTO/Compras/IDTOPedidoCompra';
import ServicoPedidoCompra from '@/servicos/Compras/ServicoPedidoCompras';
import { useModalBase } from '@/core/composables/ModalBase';
import SelecionarPessoa from '@/components/Cadastros/Pessoas/SelecionarPessoa.vue';

export default defineComponent({
  name: 'BuscarPedidoCompraModal',
  props: {
    empresa: {
      type: Number,
      required: true,
    },
    codigoFornecedor: {
      type: Number,
      required: true,
    },
    codigoPedidoCompra: {
      type: Number,
      default: 0,
    },
    numeroPedidoCompra: {
      type: Number,
      default: 0,
    },
    visivel: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Card,
    Icone,
    MensagemSemDados,
    SelecionarPessoa,
  },
  emits: ['update:codigoPedidoCompra', 'update:numeroPedidoCompra', 'update:visivel', 'confirmar'],
  setup(props, { emit }) {
    const servicoPedidoCompra = new ServicoPedidoCompra();
    servicoPedidoCompra.requisicaoSistema();

    const { modalBase } = useModalBase(props, emit);

    const state = reactive({
      valorBusca: '',
      filtroPeriodo: {} as EFiltroPeriodoMovimentoComercial,
      status: {} as EStatusPedidoCompra,
      buscandoPedidos: false,
      pedidos: [] as IDTOPedidoCompra[],
      telaMobile: false,
      importando: false,
      colunasGrade: [] as IColumn[],
      dataInicial: '',
      dataFinal: '',
    });

    const radioStyle = reactive({
      display: 'flex',
      height: '30px',
      lineHeight: '30px',
    });

    function preencherColunas() {
      if (state.telaMobile) {
        state.colunasGrade = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 1, visible: false,
          },
          {
            title: 'Número Pedido', dataIndex: 'item', key: 'Item', position: 2, visible: true, ellipsis: true,
          },
        ];
      } else {
        state.colunasGrade = [
          {
            title: 'Código', dataIndex: 'codigo', key: 'Codigo', position: 0, visible: false,
          },
          {
            title: 'Número', dataIndex: 'numeroPedido', key: 'NumeroPedido', position: 1, visible: true, width: 50, ordering: false, align: 'right', ellipsis: true,
          },
          {
            title: 'Número Pedido Fornecedor', dataIndex: 'numeroPedidoFornecedor', key: 'NumeroPedidoFornecedor', position: 2, visible: true, width: 100, align: 'right', ellipsis: true,
          },
          {
            title: 'Data Criação', dataIndex: 'dataCriacao', key: 'DataCriacao', position: 3, visible: true, ordering: false, align: 'center', width: 75, ellipsis: true,
          },
          {
            title: 'Data Previsão Entrega', dataIndex: 'dataPrevisaoEntrega', key: 'DataPrevisaoEntrega', position: 4, visible: true, ordering: false, align: 'right', width: 75, ellipsis: true,
          },
          {
            title: 'Valor R$', dataIndex: 'totalPedido', key: 'TotalPedido', position: 5, visible: true, ordering: false, align: 'right', width: 75, ellipsis: true,
          },
          {
            title: 'Ações', key: 'acoes', position: 6, visible: true, width: 50, align: 'center', ellipsis: true,
          },
        ];
      }
    }

    function limparTela() {
      state.valorBusca = '';
      state.dataInicial = '';
      state.dataFinal = '';
      state.pedidos = [];
    }

    async function buscarPedidos() {
      state.buscandoPedidos = true;
      state.pedidos = [];

      const listaPaginada = await servicoPedidoCompra.obterPorFornecedor(props.codigoFornecedor, props.empresa);
      state.pedidos = listaPaginada.dados;
      state.buscandoPedidos = false;
    }

    async function confirmar(codigo: number, numeroPedido: number) {
      emit('update:codigoPedidoCompra', codigo);
      emit('update:numeroPedidoCompra', numeroPedido);
      emit('confirmar');
      modalBase.computedVisivel = false;
    }

    watch(async () => modalBase.computedVisivel, async () => {
      limparTela();
      if (modalBase.computedVisivel) {
        preencherColunas();
        buscarPedidos();
      }
    });

    return {
      props,
      state,
      UtilitarioMascara,
      UtilitarioData,
      buscarPedidos,
      radioStyle,
      EFiltroPeriodoMovimentoComercial,
      confirmar,
      modalBase,
    };
  },
});
